import addDays from 'date-fns/addDays';
import endOfDay from 'date-fns/endOfDay';
import React, { useMemo, useRef } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import baseAPI from '../../api';
import useApplicationSettings from '../../hooks/useApplicationSettings';
import useQueryParams from '../../hooks/useQueryParams';
import useScrollWithHashParam from '../../hooks/useScrollWithHashParam';
import './styles.module.css';
import { BookingFormProvider } from './context2';
import BookingForm from './booking-form2';
import Loading from 'components/Loading';
import { ADVISOR_NAME } from 'constants/selectors';

const calendarApi = baseAPI.calendarAvailability;

const Profile: React.FunctionComponent = () => {
  const { appSettings } = useApplicationSettings();
  const { id = '' } = useParams<{ id: string }>();
  const params = useQueryParams();
  const wrapper = useRef<HTMLDivElement>(null);
  const advisorName = useMemo(() => {
    return document.querySelector(ADVISOR_NAME)?.textContent || params.get('profileName') || '';
  }, [params]);

  const startTime = new Date().toISOString();
  const endTime = endOfDay(addDays(new Date(), appSettings.bookingFormAvailabilityOffset || 24)).toISOString();

  useScrollWithHashParam(wrapper);

  const { data, isFetched } = useQuery(
    `profile-${id}`,
    () =>
      calendarApi.getAvailableAppointments(parseInt(id.toString()), {
        periodFromDate: startTime,
        periodToDate: endTime,
      }),
    { retry: false }
  );

  const loadingContainer = (
    <div className="w-full bg-app-background flex items-center justify-center h-80">
      <Loading />
    </div>
  );

  if (!isFetched) {
    return loadingContainer;
  }

  return (
    <BookingFormProvider availableSlots={data?.data || []} advisorId={id} advisorName={advisorName}>
      <div id="book" ref={wrapper} className="w-full">
        <BookingForm />
        <ToastContainer />
      </div>
    </BookingFormProvider>
  );
};

export default Profile;
